import styled from 'styled-components';
import * as cor from '../../styles/colors'

export const MessageContainer = styled.div`
  font-size: 15px;
  color: ${props => props.error ? cor.messageError : props.warn ? cor.messageWarn : props.success ? cor.messageSuccess : props.info ? cor.messageInfo : cor.messageNormal}
`